<script setup lang="ts" generic="T">
import { useElementId } from '../../common/composables/useElementId';
import { Select } from 'primevue';

const props = defineProps<{
  title: string;
  changed: boolean,
  disabled?: boolean,
  clearBtn?: boolean,
  options: T[],
  optionsValue?: string
}>();

const modelValue = defineModel<T|undefined>({ required: true });

const elementId = useElementId();

</script>

<template>
  <div class="field" :class="{ changed: props.changed }">
    <label :for="elementId">{{ props.title }}</label>
    <Select v-if="!optionsValue" autocomplete="off" :id="elementId" :options="props.options" optionLabel="name" v-model="modelValue" :disabled="disabled" :showClear="clearBtn"</Select>
    <Select v-if="optionsValue" autocomplete="off" :id="elementId" :options="props.options" optionLabel="name" :optionsValue="optionsValue" v-model="modelValue" :disabled="disabled" :showClear="clearBtn"</Select>
  </div>
</template>
